export const getChainForDextoolsUrl = (chain = "") => {
  const lowerCaseChain = chain?.toLowerCase();
  if (["bnb", "bsc", "binance"].includes(lowerCaseChain)) {
    return "bnb";
  }
  if (["eth", "ethereum", "ether"].includes(lowerCaseChain)) {
    return "ether";
  }
  if (["polygon"].includes(lowerCaseChain)) {
    return "polygon";
  }
  if (["base"].includes(lowerCaseChain)) {
    return "base";
  }
  if (["sol", "solana"].includes(lowerCaseChain)) {
    return "solana";
  }
  if (["tron"].includes(lowerCaseChain)) {
    return "tron";
  }
  if (["arb", "arbitrum"].includes(lowerCaseChain)) {
    return "arbitrum";
  }
  if (["ton"].includes(lowerCaseChain)) {
    return "ton";
  }
  if (["avalanche", "avax"].includes(lowerCaseChain)) {
    return "avalanche";
  }
  if (["optimism", "opti"].includes(lowerCaseChain)) {
    return "optimism";
  }
  return "ether";
};

export const getDextoolsChartLink = (contract: string, chain: string) => {
  return contract
    ? `https://www.dextools.io/app/en/${getChainForDextoolsUrl(
        chain
      )}/pair-explorer/${contract}`
    : "";
};
